import { render } from "./PerruquesH.vue?vue&type=template&id=62b5126c&scoped=true"
import script from "./PerruquesH.vue?vue&type=script&lang=js"
export * from "./PerruquesH.vue?vue&type=script&lang=js"

import "./PerruquesH.vue?vue&type=style&index=0&id=62b5126c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b5126c"]])

export default __exports__